var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"Header"}),_c('div',{staticClass:"Main"},[_c('Main')],1),_c('div',{staticClass:"Footer"},[(_vm.$route.meta.alive)?_c('Footer'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }